var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g2, _path14, _path15, _rect, _g3, _path16, _path17, _path18, _path19, _path20, _rect2, _rect3, _rect4, _rect5, _rect6, _path21, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g4, _rect12, _rect13, _g5, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceunavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 302.243,
    height: 205.229,
    viewBox: "0 0 302.243 205.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6542",
    "data-name": "Path 6542",
    d: "M89.142,858.072a6.436,6.436,0,0,1-9.092,4.3,55.457,55.457,0,0,0-78.384,37.5c-8.859,37.813,18.85,71.53,54.24,71.53H262.641c21.772,0,39.581-18,39.6-40.1v-.077q0-.841-.036-1.691c-.834-19.94-15.865-36.106-34.991-38.147-2.379-.4-3.973-1.988-4.146-5.731.023-1.742.049-3.557.049-4.885,0-50.052-39.573-90.627-88.389-90.627-41.168,0-75.76,28.858-85.589,67.921",
    transform: "translate(-0.001 -790.151)",
    fill: "#d7e5f4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13126",
    "data-name": "Rectangle 13126",
    width: 17.015,
    height: 36.946,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13129",
    "data-name": "Rectangle 13129",
    width: 89.842,
    height: 4.434,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13145",
    "data-name": "Rectangle 13145",
    width: 28.615,
    height: 4.549,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13148",
    "data-name": "Rectangle 13148",
    width: 15.202,
    height: 29.302,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6052",
    "data-name": "Group 6052",
    transform: "translate(-553.633 -705.385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6051",
    "data-name": "Group 6051",
    transform: "translate(373.648 173.909)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3695",
    "data-name": "Group 3695",
    transform: "translate(179.984 531.476)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12525",
    "data-name": "Rectangle 12525",
    width: 358.29,
    height: 319.98,
    transform: "translate(-89.726 53.187) rotate(-32.8)",
    fill: "#d7e5f4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10493",
    "data-name": "Path 10493",
    d: "M223.28,170.347l-102.129-11.92a7.956,7.956,0,0,0-8.824,6.98L104.7,230.713a7.956,7.956,0,0,0,6.979,8.825l102.128,11.92a7.956,7.956,0,0,0,8.825-6.98l7.623-65.306a7.957,7.957,0,0,0-6.98-8.825",
    transform: "translate(167.116 419.336)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10494",
    "data-name": "Path 10494",
    d: "M233.9,185.636l.754-6.464a7.956,7.956,0,0,0-6.98-8.825l-102.128-11.92a7.956,7.956,0,0,0-8.825,6.98l-.755,6.464Z",
    transform: "translate(162.723 419.336)",
    fill: "#B8C7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10498",
    "data-name": "Path 10498",
    d: "M132.941,171.7a2.138,2.138,0,1,1-1.876-2.372,2.139,2.139,0,0,1,1.876,2.372",
    transform: "translate(157.787 415.088)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10499",
    "data-name": "Path 10499",
    d: "M149.687,173.652a2.138,2.138,0,1,1-1.876-2.372,2.139,2.139,0,0,1,1.876,2.372",
    transform: "translate(151.284 414.33)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10500",
    "data-name": "Path 10500",
    d: "M167.045,175.679a2.138,2.138,0,1,1-1.876-2.372,2.138,2.138,0,0,1,1.876,2.372",
    transform: "translate(144.545 413.543)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10501",
    "data-name": "Path 10501",
    d: "M101.569,297.924a54.958,54.958,0,0,0-1.149,12.37c.206,5.6-.46,42.4-.46,42.4h4.5s6.4-28.823,6.638-31.1,3.458-25.039,3.458-25.039Z",
    transform: "translate(160.141 356.859)",
    fill: "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10502",
    "data-name": "Path 10502",
    d: "M107.477,296.048a96.612,96.612,0,0,0,2.793,13.45c1.759,5.587,10.4,43,10.4,43h4.5s-.828-28.823-1.138-31.1-2.586-25.039-2.586-25.039Z",
    transform: "translate(157.223 357.057)",
    fill: "#033193"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10503",
    "data-name": "Path 10503",
    d: "M129.651,388.311v3.137h8.557a.49.49,0,0,0,.271-.9,13.556,13.556,0,0,0-5.118-2.238Z",
    transform: "translate(148.613 321.234)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10504",
    "data-name": "Path 10504",
    d: "M100.334,388.311v3.137h8.557a.49.49,0,0,0,.271-.9,13.556,13.556,0,0,0-5.118-2.238Z",
    transform: "translate(159.996 321.234)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10505",
    "data-name": "Path 10505",
    d: "M118.587,233.089s2.943-4.469-.436-4.9c-2.594-.335-3.662.438-3.662.438s-2.987-.329-4.622,1.088c-1.121.971-5.232,8.5,1.417,11.227s5.232-4.251,5.232-4.251Z",
    transform: "translate(157.182 383.438)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10506",
    "data-name": "Path 10506",
    d: "M118.151,228.184c-2.594-.335-3.662.438-3.662.438s-2.987-.329-4.622,1.088c-1.12.971-5.232,8.5,1.417,11.227,3.125,1.281,4.468.418,5.014-.856-6.308,1.774-6.992-5.829-5.952-7.992,1.057-2.2,3.593-1.184,3.593-1.184.992-2.5,4.225-2.226,5.558-2.032a1.823,1.823,0,0,0-1.346-.689",
    transform: "translate(157.182 383.438)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10507",
    "data-name": "Path 10507",
    d: "M116.795,238.435s-.872-.872-1.526,0-.218,2.834.872,2.943c0,0-.327,2.834-2.507,2.725v2.289h5.123v-1.744s3.161-1.308,3.052-3.924a14.465,14.465,0,0,0-.872-4.469,7.122,7.122,0,0,1-4.142,2.18",
    transform: "translate(154.832 380.271)",
    fill: "#ffb27d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10508",
    "data-name": "Path 10508",
    d: "M118.889,250.3c.507.212.418.531.441,1.011h.737v-1.744a4.112,4.112,0,0,1-3.06-.641,8.052,8.052,0,0,0,1.882,1.374",
    transform: "translate(153.522 375.352)",
    fill: "#fd9853"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10509",
    "data-name": "Path 10509",
    d: "M119.886,232.644s-2.656-1.058-2.966-.264c-.2.519.313.967,1.022,1.419l-.625.1a.165.165,0,0,0-.08.289,3.514,3.514,0,0,0,1.66.27Z",
    transform: "translate(153.573 381.891)",
    fill: "#ffb27d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10511",
    "data-name": "Path 10511",
    d: "M100.3,290.322l.9,1.969-.437,5.942-.009.018-1.023-1.5Z",
    transform: "translate(160.228 359.279)",
    fill: "#efaa3a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6036",
    "data-name": "Group 6036",
    transform: "translate(275.787 621.187)",
    opacity: 0.29,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6035",
    "data-name": "Group 6035",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6034",
    "data-name": "Group 6034",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10512",
    "data-name": "Path 10512",
    d: "M126.983,257.261c-.855.621-.639,6.131-.85,9.576a121.418,121.418,0,0,0-.444,13.981,25.778,25.778,0,0,0,3.541-.444l.139-.032-.239-22.28a86.359,86.359,0,0,0,13.253-12.825.931.931,0,0,0-.149-1.365,113.475,113.475,0,0,1-15.253,13.389",
    transform: "translate(-125.601 -243.872)",
    fill: "#f98d2b"
  }))))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10513",
    "data-name": "Path 10513",
    d: "M131.124,324.363c-.224-1.643-1.471-13.95-2.148-20.677l-3.231.355s4.712,38.743,5.022,51.42h1.5s-.828-28.823-1.138-31.1",
    transform: "translate(150.13 354.091)",
    fill: "#000000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10526",
    "data-name": "Path 10526",
    d: "M39.918,319.146l.119-.148a.66.66,0,0,0-.119.148",
    transform: "translate(183.453 348.146)",
    fill: "#49b4d6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13127",
    "data-name": "Rectangle 13127",
    width: 89.842,
    height: 18.267,
    transform: "translate(293.771 669.438)",
    fill: "#ec6786"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6039",
    "data-name": "Group 6039",
    transform: "translate(293.771 669.438)",
    opacity: 0.29,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6038",
    "data-name": "Group 6038",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6037",
    "data-name": "Group 6037",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13128",
    "data-name": "Rectangle 13128",
    width: 89.842,
    height: 4.434,
    transform: "translate(0 0)",
    fill: "#f98d2b"
  }))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10532",
    "data-name": "Path 10532",
    d: "M166.371,322.748h8.2l-2.2,4.435h-8.2Z",
    transform: "translate(135.211 346.69)",
    fill: "#f77e2d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10533",
    "data-name": "Path 10533",
    d: "M196.574,322.748h8.2l-2.2,4.435h-8.2Z",
    transform: "translate(123.483 346.69)",
    fill: "#f77e2d"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10534",
    "data-name": "Path 10534",
    d: "M226.773,322.748h8.2l-2.2,4.435h-8.2Z",
    transform: "translate(111.758 346.69)",
    fill: "#f77e2d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10535",
    "data-name": "Path 10535",
    d: "M256.972,322.748h8.2l-2.2,4.435h-8.2Z",
    transform: "translate(100.033 346.69)",
    fill: "#f77e2d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10536",
    "data-name": "Path 10536",
    d: "M295.306,322.748v.124l-2.14,4.312h-8.191l2.2-4.435Z",
    transform: "translate(88.308 346.69)",
    fill: "#f77e2d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13130",
    "data-name": "Rectangle 13130",
    width: 6.333,
    height: 24.977,
    transform: "translate(304.955 687.706)",
    fill: "#c1c1c1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13131",
    "data-name": "Rectangle 13131",
    width: 1.439,
    height: 24.977,
    transform: "translate(309.849 687.706)",
    fill: "#b1afaf"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13132",
    "data-name": "Rectangle 13132",
    width: 6.333,
    height: 24.977,
    transform: "translate(366.589 687.706)",
    fill: "#c1c1c1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13133",
    "data-name": "Rectangle 13133",
    width: 1.873,
    height: 24.977,
    transform: "translate(371.049 687.706)",
    fill: "#b1afaf"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13134",
    "data-name": "Rectangle 13134",
    width: 6.333,
    height: 3.146,
    transform: "translate(304.955 687.687)",
    fill: "#b1afaf"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10562",
    "data-name": "Path 10562",
    d: "M23.736,19.372H9.331v7.654a6.945,6.945,0,0,1,2.731-1.87,10.109,10.109,0,0,1,3.849-.709A9.406,9.406,0,0,1,21.135,25.8a8.236,8.236,0,0,1,3.1,3.612,12.125,12.125,0,0,1,1.011,5.01,10.945,10.945,0,0,1-2.73,7.783q-2.731,2.924-7.8,2.924a13.128,13.128,0,0,1-5.762-1.183,9.2,9.2,0,0,1-3.827-3.311,9.79,9.79,0,0,1-1.505-4.966H9.5a5.269,5.269,0,0,0,1.591,3.075,4.718,4.718,0,0,0,3.311,1.139,4.484,4.484,0,0,0,3.719-1.527,6.3,6.3,0,0,0,1.226-4.063,5.157,5.157,0,0,0-1.29-3.741,4.851,4.851,0,0,0-3.655-1.333,5.41,5.41,0,0,0-2.924.753,4.483,4.483,0,0,0-1.763,2H3.827V14.04H23.736Zm6.579,10.191Q30.315,45,41.925,45q6.149,0,8.858-4.128t2.709-11.309q0-7.138-2.709-11.266t-8.858-4.128Q30.315,14.169,30.315,29.563Zm17.2,0a18.01,18.01,0,0,1-1.139,7.2q-1.14,2.515-4.451,2.515-3.354,0-4.494-2.515a18.01,18.01,0,0,1-1.139-7.2,17.873,17.873,0,0,1,1.139-7.16q1.139-2.516,4.494-2.515,3.311,0,4.451,2.515A17.873,17.873,0,0,1,47.515,29.563ZM69.488,13.481A12.06,12.06,0,0,1,74.8,14.556a7.731,7.731,0,0,1,3.354,2.967,8.01,8.01,0,0,1,1.139,4.214A7.142,7.142,0,0,1,77.7,26.531a6.769,6.769,0,0,1-4.214,2.3v.215q6.364,1.892,6.364,7.482a8.244,8.244,0,0,1-2.623,6.342q-2.623,2.43-7.4,2.43a12.205,12.205,0,0,1-8.084-2.515q-3.01-2.515-3.354-7.59h5.934a5.88,5.88,0,0,0,1.526,3.677,4.938,4.938,0,0,0,3.72,1.354A4.407,4.407,0,0,0,72.8,39.088,4,4,0,0,0,73.96,36.1a3.828,3.828,0,0,0-1.677-3.354,8.69,8.69,0,0,0-4.945-1.161H66.091V26.639h1.247q6.02.086,6.02-4.171a3.878,3.878,0,0,0-1.075-2.9,4,4,0,0,0-2.924-1.053,4.35,4.35,0,0,0-3.182,1.226,5.173,5.173,0,0,0-1.419,3.418H58.824A10.008,10.008,0,0,1,61.834,16Q64.586,13.481,69.488,13.481Z",
    transform: "matrix(0.994, 0.113, -0.113, 0.994, 297.255, 596.354)",
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13135",
    "data-name": "Rectangle 13135",
    width: 6.333,
    height: 3.146,
    transform: "translate(366.589 687.687)",
    fill: "#b1afaf"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13136",
    "data-name": "Rectangle 13136",
    width: 6.333,
    height: 2.836,
    transform: "translate(304.955 666.583)",
    fill: "#c1c1c1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13137",
    "data-name": "Rectangle 13137",
    width: 1.439,
    height: 2.836,
    transform: "translate(309.849 666.583)",
    fill: "#b1afaf"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13138",
    "data-name": "Rectangle 13138",
    width: 6.333,
    height: 2.836,
    transform: "translate(366.589 666.583)",
    fill: "#c1c1c1"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13139",
    "data-name": "Rectangle 13139",
    width: 1.873,
    height: 2.836,
    transform: "translate(371.049 666.583)",
    fill: "#b1afaf"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13140",
    "data-name": "Rectangle 13140",
    width: 6.333,
    height: 0.357,
    transform: "translate(304.955 669.065)",
    fill: "#b1afaf"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13141",
    "data-name": "Rectangle 13141",
    width: 6.333,
    height: 0.357,
    transform: "translate(366.589 669.065)",
    fill: "#b1afaf"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10537",
    "data-name": "Path 10537",
    d: "M171.011,322.748l-9.06,18.267H155v-2.52l7.812-15.747Z",
    transform: "translate(138.771 346.69)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10538",
    "data-name": "Path 10538",
    d: "M192.218,322.748l-9.06,18.267h8.2l9.06-18.267Z",
    transform: "translate(127.839 346.69)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10539",
    "data-name": "Path 10539",
    d: "M230.618,322.748l-9.06,18.267h-8.2l9.06-18.267Z",
    transform: "translate(116.113 346.69)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10540",
    "data-name": "Path 10540",
    d: "M260.812,322.748l-9.056,18.267h-8.2l9.06-18.267Z",
    transform: "translate(104.388 346.69)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10541",
    "data-name": "Path 10541",
    d: "M282.816,322.748l-9.06,18.267h8.2l9-18.143Z",
    transform: "translate(92.663 346.69)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10542",
    "data-name": "Path 10542",
    d: "M174.572,322.748l-2.2,4.435h-8.2l2.2-4.435Z",
    transform: "translate(135.211 346.69)",
    fill: "#e6e6e6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10543",
    "data-name": "Path 10543",
    d: "M204.774,322.748l-2.2,4.435h-8.2l2.2-4.435Z",
    transform: "translate(123.483 346.69)",
    fill: "#e6e6e6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10544",
    "data-name": "Path 10544",
    d: "M234.973,322.748l-2.2,4.435h-8.2l2.2-4.435Z",
    transform: "translate(111.758 346.69)",
    fill: "#e6e6e6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10545",
    "data-name": "Path 10545",
    d: "M265.168,322.748l-2.2,4.435h-8.2l2.2-4.435Z",
    transform: "translate(100.033 346.69)",
    fill: "#e6e6e6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10546",
    "data-name": "Path 10546",
    d: "M295.36,322.748l-2.195,4.453h-8.191l2.2-4.453Z",
    transform: "translate(88.308 346.672)",
    fill: "#e6e6e6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10547",
    "data-name": "Path 10547",
    d: "M180.251,308.018a5.647,5.647,0,1,0-5.647,5.647,5.647,5.647,0,0,0,5.647-5.647",
    transform: "translate(133.353 354.602)",
    fill: "#ec6786"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10548",
    "data-name": "Path 10548",
    d: "M179.122,309.978a2.559,2.559,0,1,0-2.559,2.559,2.559,2.559,0,0,0,2.559-2.559",
    transform: "translate(131.393 352.642)",
    fill: "#b1afaf"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10549",
    "data-name": "Path 10549",
    d: "M281.211,308.018a5.647,5.647,0,1,0-5.647,5.647,5.647,5.647,0,0,0,5.647-5.647",
    transform: "translate(94.153 354.602)",
    fill: "#ec6786"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10550",
    "data-name": "Path 10550",
    d: "M280.083,309.978a2.559,2.559,0,1,0-2.559,2.559,2.559,2.559,0,0,0,2.559-2.559",
    transform: "translate(92.194 352.642)",
    fill: "#b1afaf"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10551",
    "data-name": "Path 10551",
    d: "M339.343,369.949H310.73l4.376-10.609v-.006l1.761-4.281.484-1.173.79-1.91.161-.389,1.761-4.281.323-.779,3.12-7.574a1.655,1.655,0,0,1,3.059,0l3.119,7.574.324.779,1.76,4.281.161.389.79,1.91.485,1.173,1.761,4.281v.006Z",
    transform: "translate(78.308 340.798)",
    fill: "#ec6786"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6047",
    "data-name": "Group 6047",
    transform: "translate(389.038 706.197)",
    opacity: 0.29,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6046",
    "data-name": "Group 6046",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6045",
    "data-name": "Group 6045",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10552",
    "data-name": "Path 10552",
    d: "M312.606,382.838l-1.875,4.549h28.615l-1.874-4.549Z",
    transform: "translate(-310.731 -382.838)",
    fill: "#f98d2b"
  }))))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13146",
    "data-name": "Rectangle 13146",
    width: 32.772,
    height: 4.633,
    transform: "translate(386.751 708.027)",
    fill: "#c1c1c1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13147",
    "data-name": "Rectangle 13147",
    width: 7.08,
    height: 4.633,
    transform: "translate(412.442 708.027)",
    fill: "#b1afaf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6050",
    "data-name": "Group 6050",
    transform: "translate(401.323 678.723)",
    opacity: 0.29,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6049",
    "data-name": "Group 6049",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6048",
    "data-name": "Group 6048",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10553",
    "data-name": "Path 10553",
    d: "M346.015,367.229h-4.047l-3.251-7.885v-.006l-1.76-4.281-.485-1.173-.79-1.91-.161-.389-1.761-4.281-.323-.778-2.623-6.377.491-1.2a1.654,1.654,0,0,1,3.059,0l3.119,7.574.324.778,1.76,4.281.161.389.79,1.91.485,1.173,1.761,4.281v.006Z",
    transform: "translate(-330.813 -337.927)",
    fill: "#f98d2b"
  }))))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10554",
    "data-name": "Path 10554",
    d: "M336.576,357.53H323.11l1.761-4.281h9.945Z",
    transform: "translate(73.501 334.848)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10555",
    "data-name": "Path 10555",
    d: "M337.743,370.2v.006h-19.86V370.2l1.761-4.281h16.339Z",
    transform: "translate(75.53 329.926)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10556",
    "data-name": "Path 10556",
    d: "M341.436,357.53h-4.047l-1.761-4.281h4.048Z",
    transform: "translate(68.641 334.848)",
    fill: "#e6e6e6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10557",
    "data-name": "Path 10557",
    d: "M346.662,370.2v.006h-4.047V370.2l-1.761-4.281H344.9Z",
    transform: "translate(66.612 329.926)",
    fill: "#e6e6e6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10558",
    "data-name": "Path 10558",
    d: "M36.31,206.465a4.3,4.3,0,0,0,4.285-3.67,8.547,8.547,0,0,0-8.46-9.7c-.193,0-.385.009-.575.021a9.07,9.07,0,0,0-18.108.767c0,.223.011.442.026.66A9.071,9.071,0,0,0,.014,201.807c0,.036,0,.073-.006.108a4.322,4.322,0,0,0,4.332,4.549Z",
    transform: "translate(198.952 420.245)",
    fill: "#a9c2ff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10559",
    "data-name": "Path 10559",
    d: "M368.586,218.693c6.752,0,7.126-10.162.382-10.49q-.276-.014-.556-.013a11.27,11.27,0,0,0-3.451.54,11.586,11.586,0,0,0-22.916.366,10.725,10.725,0,0,0-7.281-.708c-5.9,1.521-4.665,10.305,1.431,10.305Z",
    transform: "translate(70.468 399.724)",
    fill: "#a9c2ff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10560",
    "data-name": "Path 10560",
    d: "M236.036,136.848c6.751,0,7.124-10.159.382-10.487-.184-.009-.369-.013-.556-.013a11.262,11.262,0,0,0-3.45.54,11.582,11.582,0,0,0-22.91.366,10.72,10.72,0,0,0-7.28-.708c-5.9,1.52-4.663,10.3,1.431,10.3Z",
    transform: "translate(121.927 431.499)",
    fill: "#a9c2ff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10510",
    "data-name": "Path 10510",
    d: "M126.332,239.585c-5.063-3.752-18.893-6.752-18.893-6.752l-1.14,2.077s12.555,4.865,11.726,5.59c-.487.428-6.622,3.239-8.7,4.185a3.308,3.308,0,0,1-1.428.293l-6.356-.036a10.032,10.032,0,0,0-8.194,3.6c-3.226,3.712-8.708,12.307-8.708,12.307l9.234,13.582,1.023,1.5.009-.018-.009.126s.329.036.91.09c2.969.275,12.483,1.027,17.519-.04l.14-.032-.239-22.28A86.3,86.3,0,0,0,126.48,240.95a.931.931,0,0,0-.148-1.365M95.344,269.97l-.9-1.969-2.869-6.27,4.761-5.334-.856,11.7Z",
    transform: "translate(166.089 381.6)",
    fill: "#b3e5db"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10561",
    "data-name": "Path 10561",
    d: "M9.035-4.615a4.875,4.875,0,0,1-.578,2.4A4.052,4.052,0,0,1,6.792-.585,5.307,5.307,0,0,1,4.238,0H.767V-9.191H4.238A5.4,5.4,0,0,1,6.8-8.619,3.991,3.991,0,0,1,8.457-7.007,4.838,4.838,0,0,1,9.035-4.615ZM4.043-1.989a2.809,2.809,0,0,0,2.022-.689,2.551,2.551,0,0,0,.721-1.937,2.551,2.551,0,0,0-.721-1.937,2.809,2.809,0,0,0-2.022-.689H2.99v5.252Zm9.334-5.356a2.626,2.626,0,0,1,1.43.377,2.266,2.266,0,0,1,.884,1.027V-7.254H17.9V0h-2.21V-1.313a2.266,2.266,0,0,1-.884,1.027,2.626,2.626,0,0,1-1.43.377,2.938,2.938,0,0,1-1.606-.448,3.068,3.068,0,0,1-1.118-1.294,4.483,4.483,0,0,1-.41-1.976,4.473,4.473,0,0,1,.41-1.982A3.076,3.076,0,0,1,11.771-6.9,2.938,2.938,0,0,1,13.377-7.345Zm.715,1.95a1.5,1.5,0,0,0-1.151.468,1.835,1.835,0,0,0-.435,1.3,1.835,1.835,0,0,0,.435,1.3,1.5,1.5,0,0,0,1.151.468,1.5,1.5,0,0,0,1.151-.481,1.812,1.812,0,0,0,.448-1.287,1.807,1.807,0,0,0-.448-1.294A1.513,1.513,0,0,0,14.092-5.395Zm9.776,3.484V0h-1a2.88,2.88,0,0,1-1.983-.631,2.673,2.673,0,0,1-.708-2.086V-5.382H19.2V-7.254h.975V-9.035H22.4v1.781h1.456v1.872H22.4v2.7a.815.815,0,0,0,.176.6.839.839,0,0,0,.591.169ZM28.2-7.345a2.626,2.626,0,0,1,1.43.377,2.266,2.266,0,0,1,.884,1.027V-7.254h2.21V0h-2.21V-1.313a2.266,2.266,0,0,1-.884,1.027A2.626,2.626,0,0,1,28.2.091a2.938,2.938,0,0,1-1.606-.448,3.068,3.068,0,0,1-1.118-1.294,4.483,4.483,0,0,1-.41-1.976,4.473,4.473,0,0,1,.41-1.982A3.076,3.076,0,0,1,26.591-6.9,2.938,2.938,0,0,1,28.2-7.345Zm.715,1.95a1.5,1.5,0,0,0-1.15.468,1.835,1.835,0,0,0-.435,1.3,1.835,1.835,0,0,0,.435,1.3,1.5,1.5,0,0,0,1.15.468,1.5,1.5,0,0,0,1.151-.481,1.812,1.812,0,0,0,.448-1.287,1.807,1.807,0,0,0-.448-1.294A1.513,1.513,0,0,0,28.912-5.395ZM44.72-7.254V0H42.484V-1.313A2.41,2.41,0,0,1,41.555-.3a2.7,2.7,0,0,1-1.437.377,2.511,2.511,0,0,1-1.983-.832A3.337,3.337,0,0,1,37.4-3.042V-7.254h2.21v3.939a1.618,1.618,0,0,0,.383,1.151,1.348,1.348,0,0,0,1.034.409,1.369,1.369,0,0,0,1.066-.429,1.754,1.754,0,0,0,.39-1.222V-7.254Zm6.461-.078a2.511,2.511,0,0,1,1.983.832A3.337,3.337,0,0,1,53.9-4.212V0H51.675V-3.952a1.6,1.6,0,0,0-.383-1.138,1.332,1.332,0,0,0-1.021-.41A1.389,1.389,0,0,0,49.2-5.07a1.735,1.735,0,0,0-.4,1.222V0H46.579V-7.254H48.8v1.326a2.393,2.393,0,0,1,.929-1.027A2.726,2.726,0,0,1,51.181-7.332Zm7.267-.013a2.626,2.626,0,0,1,1.43.377,2.266,2.266,0,0,1,.884,1.027V-7.254h2.21V0h-2.21V-1.313a2.266,2.266,0,0,1-.884,1.027,2.626,2.626,0,0,1-1.43.377,2.938,2.938,0,0,1-1.605-.448,3.068,3.068,0,0,1-1.118-1.294,4.483,4.483,0,0,1-.41-1.976,4.473,4.473,0,0,1,.41-1.982A3.076,3.076,0,0,1,56.842-6.9,2.938,2.938,0,0,1,58.448-7.345Zm.715,1.95a1.5,1.5,0,0,0-1.15.468,1.835,1.835,0,0,0-.436,1.3,1.835,1.835,0,0,0,.436,1.3,1.5,1.5,0,0,0,1.15.468,1.5,1.5,0,0,0,1.151-.481,1.812,1.812,0,0,0,.449-1.287,1.807,1.807,0,0,0-.449-1.294A1.513,1.513,0,0,0,59.163-5.395Zm9.022,3.224,1.573-5.083h2.366L69.55,0H66.794L64.22-7.254h2.366Zm7.943-5.174a2.626,2.626,0,0,1,1.43.377,2.266,2.266,0,0,1,.884,1.027V-7.254h2.21V0h-2.21V-1.313a2.266,2.266,0,0,1-.884,1.027,2.626,2.626,0,0,1-1.43.377,2.938,2.938,0,0,1-1.605-.448A3.068,3.068,0,0,1,73.4-1.651,4.483,4.483,0,0,1,73-3.627a4.473,4.473,0,0,1,.41-1.982A3.076,3.076,0,0,1,74.523-6.9,2.938,2.938,0,0,1,76.128-7.345Zm.715,1.95a1.5,1.5,0,0,0-1.15.468,1.835,1.835,0,0,0-.436,1.3,1.835,1.835,0,0,0,.436,1.3,1.5,1.5,0,0,0,1.15.468,1.5,1.5,0,0,0,1.15-.481,1.812,1.812,0,0,0,.449-1.287,1.807,1.807,0,0,0-.449-1.294A1.513,1.513,0,0,0,76.843-5.395ZM82.3-9.3a1.085,1.085,0,0,1,.364-.839,1.373,1.373,0,0,1,.962-.332,1.373,1.373,0,0,1,.962.332,1.085,1.085,0,0,1,.364.839,1.071,1.071,0,0,1-.364.826,1.373,1.373,0,0,1-.962.332,1.373,1.373,0,0,1-.962-.332A1.071,1.071,0,0,1,82.3-9.3Zm2.431,2.041V0H82.511V-7.254ZM88.816-9.62V0H86.593V-9.62Zm4.615,2.275a2.626,2.626,0,0,1,1.43.377,2.266,2.266,0,0,1,.884,1.027V-7.254h2.21V0h-2.21V-1.313a2.266,2.266,0,0,1-.884,1.027,2.626,2.626,0,0,1-1.43.377,2.938,2.938,0,0,1-1.605-.448,3.068,3.068,0,0,1-1.118-1.294,4.483,4.483,0,0,1-.41-1.976,4.473,4.473,0,0,1,.41-1.982A3.076,3.076,0,0,1,91.826-6.9,2.938,2.938,0,0,1,93.431-7.345Zm.715,1.95A1.5,1.5,0,0,0,93-4.927a1.835,1.835,0,0,0-.436,1.3A1.835,1.835,0,0,0,93-2.327a1.5,1.5,0,0,0,1.15.468A1.5,1.5,0,0,0,95.3-2.34a1.812,1.812,0,0,0,.449-1.287A1.807,1.807,0,0,0,95.3-4.921,1.513,1.513,0,0,0,94.146-5.395Zm10.192-1.95a2.938,2.938,0,0,1,1.605.448,3.076,3.076,0,0,1,1.118,1.287,4.473,4.473,0,0,1,.409,1.982,4.483,4.483,0,0,1-.409,1.976,3.068,3.068,0,0,1-1.118,1.294,2.938,2.938,0,0,1-1.605.448,2.626,2.626,0,0,1-1.43-.377,2.189,2.189,0,0,1-.871-1.027V0H99.814V-9.62h2.223v3.679a2.189,2.189,0,0,1,.871-1.027A2.626,2.626,0,0,1,104.338-7.345Zm-.715,1.95a1.513,1.513,0,0,0-1.151.474,1.807,1.807,0,0,0-.449,1.294,1.812,1.812,0,0,0,.449,1.287,1.5,1.5,0,0,0,1.151.481,1.5,1.5,0,0,0,1.15-.468,1.835,1.835,0,0,0,.436-1.3,1.835,1.835,0,0,0-.436-1.3A1.5,1.5,0,0,0,103.623-5.395Zm7.553-4.225V0h-2.223V-9.62Zm8.749,5.8a3.067,3.067,0,0,1-.065.6h-5.031a1.681,1.681,0,0,0,.416,1.177,1.342,1.342,0,0,0,.962.357,1.315,1.315,0,0,0,.819-.247,1.153,1.153,0,0,0,.429-.637h2.353a3.074,3.074,0,0,1-.624,1.371,3.326,3.326,0,0,1-1.222.949,3.869,3.869,0,0,1-1.651.345,3.9,3.9,0,0,1-1.892-.448,3.2,3.2,0,0,1-1.293-1.294,4.013,4.013,0,0,1-.468-1.976,4.05,4.05,0,0,1,.462-1.982A3.163,3.163,0,0,1,114.413-6.9a3.936,3.936,0,0,1,1.9-.448,3.935,3.935,0,0,1,1.9.442,3.123,3.123,0,0,1,1.268,1.242A3.7,3.7,0,0,1,119.925-3.822Zm-2.249-.338a1.336,1.336,0,0,0-.383-1.073,1.412,1.412,0,0,0-.981-.358,1.456,1.456,0,0,0-1.014.364,1.524,1.524,0,0,0-.455,1.066Zm5.642,1.937V0h-2.3V-2.223Zm6.63-1V0h-2.223V-9.191h3.6a3.5,3.5,0,0,1,2.5.813,2.874,2.874,0,0,1,.858,2.19,3.018,3.018,0,0,1-.383,1.528,2.659,2.659,0,0,1-1.137,1.053,4.007,4.007,0,0,1-1.833.384Zm1.131-1.781q1.339,0,1.339-1.183,0-1.209-1.339-1.209h-1.131v2.392ZM138.32-9.62V0H136.1V-9.62Zm8.749,5.8a3.066,3.066,0,0,1-.065.6h-5.031a1.681,1.681,0,0,0,.416,1.177,1.342,1.342,0,0,0,.962.357,1.315,1.315,0,0,0,.819-.247,1.153,1.153,0,0,0,.429-.637h2.353a3.074,3.074,0,0,1-.624,1.371,3.326,3.326,0,0,1-1.222.949,3.869,3.869,0,0,1-1.651.345,3.9,3.9,0,0,1-1.891-.448,3.2,3.2,0,0,1-1.294-1.294,4.013,4.013,0,0,1-.468-1.976,4.05,4.05,0,0,1,.462-1.982A3.163,3.163,0,0,1,141.557-6.9a3.936,3.936,0,0,1,1.9-.448,3.935,3.935,0,0,1,1.9.442,3.122,3.122,0,0,1,1.268,1.242A3.7,3.7,0,0,1,147.069-3.822ZM144.82-4.16a1.336,1.336,0,0,0-.383-1.073,1.412,1.412,0,0,0-.982-.358,1.456,1.456,0,0,0-1.014.364,1.524,1.524,0,0,0-.455,1.066Zm6.487-3.185a2.626,2.626,0,0,1,1.43.377,2.266,2.266,0,0,1,.884,1.027V-7.254h2.21V0h-2.21V-1.313a2.266,2.266,0,0,1-.884,1.027,2.626,2.626,0,0,1-1.43.377A2.938,2.938,0,0,1,149.7-.357a3.068,3.068,0,0,1-1.118-1.294,4.483,4.483,0,0,1-.41-1.976,4.473,4.473,0,0,1,.41-1.982A3.076,3.076,0,0,1,149.7-6.9,2.938,2.938,0,0,1,151.307-7.345Zm.715,1.95a1.5,1.5,0,0,0-1.151.468,1.835,1.835,0,0,0-.436,1.3,1.835,1.835,0,0,0,.436,1.3,1.5,1.5,0,0,0,1.151.468,1.5,1.5,0,0,0,1.15-.481,1.812,1.812,0,0,0,.449-1.287,1.807,1.807,0,0,0-.449-1.294A1.513,1.513,0,0,0,152.022-5.395Zm8.307-1.95a3.328,3.328,0,0,1,2.2.689,2.994,2.994,0,0,1,1.034,1.82h-2.08a1.152,1.152,0,0,0-.41-.7,1.244,1.244,0,0,0-.8-.253.874.874,0,0,0-.572.162.567.567,0,0,0-.195.461.541.541,0,0,0,.357.507,5.7,5.7,0,0,0,1.124.338,11.167,11.167,0,0,1,1.365.4,2.252,2.252,0,0,1,.923.657,1.814,1.814,0,0,1,.39,1.222,1.874,1.874,0,0,1-.338,1.105,2.225,2.225,0,0,1-.975.754,3.81,3.81,0,0,1-1.508.273,3.883,3.883,0,0,1-2.353-.65,2.743,2.743,0,0,1-1.079-1.859h2.145a.965.965,0,0,0,.4.715,1.493,1.493,0,0,0,.89.247.829.829,0,0,0,.572-.175.591.591,0,0,0,.195-.462.555.555,0,0,0-.357-.539,6.573,6.573,0,0,0-1.163-.345,9.3,9.3,0,0,1-1.326-.364,2.189,2.189,0,0,1-.9-.63,1.756,1.756,0,0,1-.377-1.19,1.941,1.941,0,0,1,.741-1.579A3.229,3.229,0,0,1,160.329-7.345ZM172.12-3.822a3.066,3.066,0,0,1-.065.6h-5.031a1.681,1.681,0,0,0,.416,1.177,1.342,1.342,0,0,0,.962.357,1.315,1.315,0,0,0,.819-.247,1.153,1.153,0,0,0,.429-.637H172a3.074,3.074,0,0,1-.624,1.371,3.326,3.326,0,0,1-1.222.949,3.869,3.869,0,0,1-1.651.345,3.9,3.9,0,0,1-1.891-.448,3.2,3.2,0,0,1-1.294-1.294,4.013,4.013,0,0,1-.468-1.976,4.05,4.05,0,0,1,.462-1.982A3.163,3.163,0,0,1,166.608-6.9a3.936,3.936,0,0,1,1.9-.448,3.935,3.935,0,0,1,1.9.442,3.122,3.122,0,0,1,1.268,1.242A3.7,3.7,0,0,1,172.12-3.822Zm-2.249-.338a1.336,1.336,0,0,0-.383-1.073,1.412,1.412,0,0,0-.982-.358,1.456,1.456,0,0,0-1.014.364,1.524,1.524,0,0,0-.455,1.066Zm10.764,2.249V0h-1a2.88,2.88,0,0,1-1.982-.631,2.673,2.673,0,0,1-.708-2.086V-5.382h-.975V-7.254h.975V-9.035h2.223v1.781h1.456v1.872h-1.456v2.7a.815.815,0,0,0,.175.6.839.839,0,0,0,.592.169Zm3.8-3.978A3.154,3.154,0,0,1,185.5-6.942a2.738,2.738,0,0,1,1.424-.39v2.379h-.637a2.2,2.2,0,0,0-1.372.377,1.514,1.514,0,0,0-.487,1.274V0h-2.223V-7.254h2.223Zm5.434-1.365,1.742,4.446,1.625-4.446h2.457L191.165,3.458h-2.444l1.7-3.731-3.042-6.981Zm12.181-.091a2.626,2.626,0,0,1,1.43.377,2.266,2.266,0,0,1,.884,1.027V-7.254h2.21V0h-2.21V-1.313a2.266,2.266,0,0,1-.884,1.027,2.626,2.626,0,0,1-1.43.377,2.938,2.938,0,0,1-1.605-.448,3.068,3.068,0,0,1-1.118-1.294,4.483,4.483,0,0,1-.41-1.976,4.473,4.473,0,0,1,.41-1.982A3.076,3.076,0,0,1,200.44-6.9,2.938,2.938,0,0,1,202.046-7.345Zm.715,1.95a1.5,1.5,0,0,0-1.151.468,1.835,1.835,0,0,0-.436,1.3,1.835,1.835,0,0,0,.436,1.3,1.5,1.5,0,0,0,1.151.468,1.5,1.5,0,0,0,1.15-.481,1.812,1.812,0,0,0,.449-1.287,1.807,1.807,0,0,0-.449-1.294A1.513,1.513,0,0,0,202.761-5.395Zm8.229-1.95a2.626,2.626,0,0,1,1.43.377,2.266,2.266,0,0,1,.884,1.027V-7.254h2.21V-.039a4.168,4.168,0,0,1-.39,1.827,2.991,2.991,0,0,1-1.2,1.294,3.848,3.848,0,0,1-2,.481,4.115,4.115,0,0,1-2.62-.773,3.147,3.147,0,0,1-1.176-2.1h2.2a1.1,1.1,0,0,0,.475.689,1.717,1.717,0,0,0,.968.247,1.558,1.558,0,0,0,1.112-.4A1.668,1.668,0,0,0,213.3-.039V-1.313a2.266,2.266,0,0,1-.884,1.027,2.626,2.626,0,0,1-1.43.377,2.938,2.938,0,0,1-1.605-.448,3.068,3.068,0,0,1-1.118-1.294,4.483,4.483,0,0,1-.41-1.976,4.473,4.473,0,0,1,.41-1.982A3.076,3.076,0,0,1,209.384-6.9,2.938,2.938,0,0,1,210.99-7.345Zm.715,1.95a1.5,1.5,0,0,0-1.151.468,1.835,1.835,0,0,0-.436,1.3,1.835,1.835,0,0,0,.436,1.3,1.5,1.5,0,0,0,1.151.468,1.5,1.5,0,0,0,1.15-.481,1.812,1.812,0,0,0,.449-1.287,1.807,1.807,0,0,0-.449-1.294A1.513,1.513,0,0,0,211.705-5.395Zm8.229-1.95a2.626,2.626,0,0,1,1.43.377,2.266,2.266,0,0,1,.884,1.027V-7.254h2.21V0h-2.21V-1.313a2.266,2.266,0,0,1-.884,1.027,2.626,2.626,0,0,1-1.43.377,2.938,2.938,0,0,1-1.605-.448,3.068,3.068,0,0,1-1.118-1.294,4.483,4.483,0,0,1-.41-1.976,4.473,4.473,0,0,1,.41-1.982A3.076,3.076,0,0,1,218.328-6.9,2.938,2.938,0,0,1,219.934-7.345Zm.715,1.95a1.5,1.5,0,0,0-1.151.468,1.835,1.835,0,0,0-.436,1.3,1.835,1.835,0,0,0,.436,1.3,1.5,1.5,0,0,0,1.151.468,1.5,1.5,0,0,0,1.15-.481,1.812,1.812,0,0,0,.449-1.287,1.807,1.807,0,0,0-.449-1.294A1.513,1.513,0,0,0,220.649-5.395Zm5.265-3.9a1.085,1.085,0,0,1,.364-.839,1.373,1.373,0,0,1,.962-.332,1.373,1.373,0,0,1,.962.332,1.085,1.085,0,0,1,.364.839,1.071,1.071,0,0,1-.364.826,1.373,1.373,0,0,1-.962.332,1.373,1.373,0,0,1-.962-.332A1.071,1.071,0,0,1,225.914-9.3Zm2.431,2.041V0h-2.223V-7.254Zm6.266-.078a2.511,2.511,0,0,1,1.982.832,3.337,3.337,0,0,1,.734,2.288V0h-2.223V-3.952a1.6,1.6,0,0,0-.384-1.138,1.332,1.332,0,0,0-1.02-.41,1.389,1.389,0,0,0-1.072.429,1.735,1.735,0,0,0-.4,1.222V0h-2.223V-7.254h2.223v1.326a2.393,2.393,0,0,1,.929-1.027A2.726,2.726,0,0,1,234.611-7.332Zm9.464-2.288V0h-2.223V-9.62Zm4.615,2.275a2.626,2.626,0,0,1,1.43.377A2.266,2.266,0,0,1,251-5.941V-7.254h2.21V0H251V-1.313a2.266,2.266,0,0,1-.884,1.027,2.626,2.626,0,0,1-1.43.377,2.938,2.938,0,0,1-1.605-.448,3.068,3.068,0,0,1-1.118-1.294,4.483,4.483,0,0,1-.41-1.976,4.473,4.473,0,0,1,.41-1.982A3.076,3.076,0,0,1,247.084-6.9,2.938,2.938,0,0,1,248.69-7.345Zm.715,1.95a1.5,1.5,0,0,0-1.151.468,1.835,1.835,0,0,0-.436,1.3,1.835,1.835,0,0,0,.436,1.3,1.5,1.5,0,0,0,1.151.468,1.5,1.5,0,0,0,1.15-.481A1.812,1.812,0,0,0,251-3.627a1.807,1.807,0,0,0-.449-1.294A1.513,1.513,0,0,0,249.4-5.395Zm9.776,3.484V0h-1A2.88,2.88,0,0,1,256.2-.631a2.673,2.673,0,0,1-.709-2.086V-5.382h-.975V-7.254h.975V-9.035h2.223v1.781h1.456v1.872h-1.456v2.7a.815.815,0,0,0,.176.6.839.839,0,0,0,.591.169Zm8.463-1.911a3.066,3.066,0,0,1-.065.6h-5.031a1.681,1.681,0,0,0,.416,1.177,1.342,1.342,0,0,0,.962.357,1.315,1.315,0,0,0,.819-.247,1.153,1.153,0,0,0,.429-.637h2.353A3.074,3.074,0,0,1,266.9-1.2a3.326,3.326,0,0,1-1.222.949,3.869,3.869,0,0,1-1.651.345,3.9,3.9,0,0,1-1.892-.448,3.2,3.2,0,0,1-1.293-1.294,4.014,4.014,0,0,1-.468-1.976,4.05,4.05,0,0,1,.461-1.982A3.163,3.163,0,0,1,262.132-6.9a3.936,3.936,0,0,1,1.9-.448,3.935,3.935,0,0,1,1.9.442A3.122,3.122,0,0,1,267.2-5.661,3.7,3.7,0,0,1,267.644-3.822Zm-2.249-.338a1.337,1.337,0,0,0-.383-1.073,1.412,1.412,0,0,0-.982-.358,1.456,1.456,0,0,0-1.014.364,1.524,1.524,0,0,0-.455,1.066Zm5.954-1.729a3.155,3.155,0,0,1,1.073-1.053,2.738,2.738,0,0,1,1.423-.39v2.379h-.637a2.2,2.2,0,0,0-1.371.377,1.514,1.514,0,0,0-.488,1.274V0h-2.223V-7.254h2.223Zm5.668,3.666V0h-2.3V-2.223Z",
    transform: "translate(190.757 733.143)",
    fill: "#cfcfd0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceunavailable);
export default __webpack_public_path__ + "static/media/Service unavailable.0c01283a3cd44b0a67066991a6b0a393.svg";
export { ForwardRef as ReactComponent };